// extracted by mini-css-extract-plugin
module.exports = {"container":"newBusinessInsightsMenu_container__1V3ZV","insightsList":"newBusinessInsightsMenu_insightsList__Sqlue","active":"newBusinessInsightsMenu_active__wO-Bn"};